import WizardStart from '../common/wizard-start'
import WizardImages from '../common/wizard-images'
import WizardPallette from '../common/wizard-palette'
import WizardComplete from '../common/wizard-complete'

import RailRetailer from '../rail/retailer'

import BusinessTitle from '../business/title'
import BusinessContacs from '../business/contacts'
import BusinessVCF from '../business/vcf'

import StampImages from '../stamp/images'
import StampConfig from '../stamp/config'
import StampComplete from '../stamp/complete'

import LoyaltyConfig from '../loyalty/config'
import LoyaltyComplete from '../loyalty/complete'

import EventConfig from '../event/config'
import GiftConfig from '../gift/config'

const railTickets = {
    Start : WizardStart,
    "Retailer Info" : RailRetailer,
    Complete : WizardComplete
  }

export default {
  none : {
    none : WizardStart
  },

  
  standard : {
    Start : WizardStart,
    Images : WizardImages,
    Colours : WizardPallette,
    Complete : WizardComplete
  },

  D01 : railTickets,
  D04 : railTickets,
  D10 : railTickets,
  D11 : railTickets,
  D13 : railTickets,

  smartix_business : {
    Start : WizardStart,
    Title : BusinessTitle,
    Images : WizardImages,
    Colours : WizardPallette,
    "Contact Details" : BusinessContacs,
    "Create VCF file" : BusinessVCF,
    Complete : WizardComplete
  },

  smartix_event : {
    Start : WizardStart,
    Images : WizardImages,
    Colours : WizardPallette,
    "Ticket Config" : EventConfig,
    Complete : WizardComplete
  },
  smartix_event_bg : {
    Start : WizardStart,
    Images : WizardImages,
    Colours : WizardPallette,
    "Ticket Config" : EventConfig,
    Complete : WizardComplete
  },
  smartix_stamp : {
    Start : WizardStart,
    Logos : WizardImages,
    "Stamp Images" : StampImages,
    Colours : WizardPallette,
    "Stamp Config" : StampConfig,
    "Stamp Complete" : StampComplete
  },

  smartix_loyalty : {
    Start : WizardStart,
    Logos : WizardImages,
    Colours : WizardPallette,
    "Loyalty Config" : LoyaltyConfig,
    "Loyalty Complete" : LoyaltyComplete
  },

  smartix_gift : {
    Start : WizardStart,
    Logos : WizardImages,
    Colours : WizardPallette,
    "Gift Config" : GiftConfig,
    Complete : WizardComplete    
  }
}